export const fontFamily = 'SansOri, SansOriFallback, sans-serif';
export const fontFamilyCondensed = 'SansCondensedOri, SansCondensedOriFallback, sans-serif';
export const fontWeightLight = 400;
export const fontWeightRegular = 400;
export const fontWeightMedium = 700;
export const fontWeightBold = 700;
export const htmlFontSize = 10;
export const htmlFontSizeAdjust = '63%';
//# sourceMappingURL=font.js.map